<template>
  <v-container>
    <mensajeSistema></mensajeSistema>
    <ComunDialogComp Deletedialog v-model="mostrarDialogConfirm" titleWindow="Desactivar muestra"
      @delete-item="confirmDeleteMuestra" @close-modal="mostrarDialogConfirm = false"
      @cancel-item="mostrarDialogConfirm = false">
      <template v-slot:body>
        {{ mensajeDialog }}
      </template>
    </ComunDialogComp>

    <!-- SNACKBAR DE MODIFICACION DE ORDENES -->
    <v-snackbar :color="colorsnackbarAlert" v-model="snackbarAlert" :timeout="timeout" top>
      <v-icon>mdi-message</v-icon>
      {{ SnackbarTextAlert }}

      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbarAlert = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <v-row>
      <v-col class="d-flex align-center" cols="12" sm="7" md="7" lg="9">
        <!-- <chipSimulador :properties="chipArrayDiff"></chipSimulador> -->
      </v-col>

      <!-- TABLAS DEL DOCENTE -->
      <v-col cols="12" sm="5" md="5" lg="3">
        <div style="display: flex; align-items: baseline;">
          <v-text-field v-model="busquedaValor" placeholder="Buscar" append-icon="fa-search" class="mr-2"
            color="primary" @keyup="((paginaActual = 1), (buscando = 1)), listarMuestra()">
          </v-text-field>
          <v-tooltip v-if="!$vuetify.breakpoint.xsOnly" bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="showGridorList = !showGridorList">
                <v-icon>
                  {{ showGridorList ? "fas fa-th-large" : "fas fa-th-list" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              showGridorList ? "Cambiar a grillas" : "Cambiar a lista"
            }}</span>
          </v-tooltip>
        </div>
      </v-col>

      <!-- VISTA TABLA -->
      <v-col v-if="showGridorList && !$vuetify.breakpoint.xsOnly" cols="12">
        <v-sheet color="transparent" class="" v-if="readyloadLista">
          <v-skeleton-loader class="mx-auto" type="table-thead, table-row-divider@3, table-tfoot"></v-skeleton-loader>
        </v-sheet>

        <v-simple-table v-else fixed-header>
          <thead>
            <tr>
              <th v-for="titulo in cabecera" :key="titulo.valor" style="
                  background:rgb(224 224 224);
                  cursor: pointer;
                  font-size: 12px !important;
                " :class="titulo.clase" @click="ordenPorColumnaDoc(titulo.valor_accion)">
                <v-icon color="dark" size="20" v-if="titulosColumna[titulo.valor_accion] || titulo.exclusion">{{
                  titulo.icono }}</v-icon><v-icon v-else color="dark" size="20">
                  {{ titulo.icono_accion }} </v-icon>{{ titulo.valor }}
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Si la tabla esta vacia un mensaje -->
            <tr v-if="totalregistros == 0">
              <td class="text-center" colspan="6">
                {{ MensajeNoExisteData }}
              </td>
            </tr>
            <!-- Si la tabla no esta vacia -->
            <template v-else>
              <tr v-for="(muestra, index) in itemArrayMuestras" :key="index" :class="index == 0 && hearChangeTab">
                <td class="shrink-column">

                  <div class="d-flex">
                    <ButtonComp class="mr-3" @click="desactivarSimulador(muestra.idmuestra, muestra.tipo_contenido)"
                      tooltipText="Desactivar muestra" class-color="error" icon-but="fa-times" />
                    <ButtonComp @click="
                      listarRespuestasPreguntas(
                        muestra.tipo_contenido,
                        $event,
                        muestra.muestra[0].idexamen,
                        muestra.muestra[0].idusuario
                      )
                      " tooltipText="Ver simulador" class-color="warning" icon-but="fa-eye" />
                    <ButtonComp class="ml-4"
                      @click="openVisorExamenesMuestra(muestra.muestra, muestra.tipo_contenido, muestra.clases)"
                      :tooltipText="muestra.muestra.length == 1 ? 'Ver estudiante' : 'Ver estudiantes'"
                      class-color="primary" :icon-but="muestra.muestra.length == 1 ? 'fa-user' : 'fa-users'" />
                  </div>

                </td>
                <td v-if="muestra.perfil == 'DOCENTE'">
                  <v-chip class="ma-2" color="blue" text-color="white" v-if="muestra && muestra.muestra">
                    <v-avatar left class="blue darken-4">
                      {{ muestra.muestra.length }}
                    </v-avatar>
                    <strong> Estudiantes</strong>
                  </v-chip>
                  <v-chip class="ma-2" color="blue" text-color="white" v-else>
                    <v-avatar left class="blue darken-4">
                      0
                    </v-avatar>
                    <strong>Estudiantes</strong>
                  </v-chip>
                </td>

                <td v-else-if="muestra.perfil == 'FAMILIAR'">
                  <v-chip class="ma-2" color="blue" text-color="white" v-if="muestra && muestra.muestra">
                    <v-avatar left class="blue darken-4">
                      {{ muestra.muestra.length }}
                    </v-avatar>
                    <strong> {{ muestra.muestra.length == 1 ? 'Único' : 'Estudiantes' }} </strong>
                  </v-chip>
                  <v-chip class="ma-2" color="blue" text-color="white" v-else>
                    <v-avatar left class="blue darken-4">
                      0
                    </v-avatar>
                    <strong>{{ muestra.muestra.length == 1 ? 'Único' : 'Estudiantes' }} {{ muestra.muestra.length
                    }}</strong>
                  </v-chip>
                </td>

                <td v-else>
                  <v-chip class="ma-2" color="blue" text-color="white">
                    <v-avatar left class="blue darken-4">
                      1
                    </v-avatar>
                    <strong>Único</strong>
                  </v-chip>
                  <!-- <v-chip class="ma-2" color="blue" text-color="white">
                    <v-avatar left class="blue darken-4">
                      Unico
                    </v-avatar>
                  </v-chip> -->
                </td>
                <td>📅{{ muestra.fecha_creacion.split(' ')[0] }} ⏰{{ muestra.fecha_creacion.split(' ')[1] }}</td>
                <td>{{ muestra.codigo }}</td>
                <td>
                  <strong> {{ muestra.perfil }} </strong>
                  <!-- {{ muestra.tipo_contenido == 1 ? 'Inteligenio':'Colegio'  }} -->
                </td>
                <td>
                  <v-chip class="ma-2" small :color="muestra.estado ? 'green lighten-1' : 'red lighten-1'
                    " text-color="white">
                    <strong>{{
                      muestra.estado ? "Activo" : "Inactivo"
                    }}</strong>
                  </v-chip>
                </td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </v-col>

      <!-- VISTA GRID -->
      <template v-else>
        <div class="w-100 text-center" v-if="totalregistros == 0">
          <p>
            {{ MensajeNoExisteData }}
          </p>
        </div>

        <template v-else>
          <v-col cols="12" sm="6" md="3" lg="3" v-for="item in itemArrayMuestras" :key="item.idmuestra">
            <v-card max-width="250" class="mx-auto">
              <v-system-bar color="primary" dark>
                <strong style="text-align: center; height: 20px" class="text-uppercase">
                  ✍ EXAMEN SIMULADOR
                </strong>
                <v-spacer></v-spacer>
              </v-system-bar>
              <v-list-item>
                <v-list-item-content>

                  <div class="text-overline mb-4">
                    {{ item.perfil }}
                  </div>

                  <v-list-item-title class="text-capitalize text-h7 mb-1">
                    Grupo #{{ item.idmuestra }}
                  </v-list-item-title>

                  <v-list-item-subtitle> Código: {{ item.codigo }}</v-list-item-subtitle>

                </v-list-item-content>

                <v-list-item-avatar size="50" style="border-radius: 0;">
                  <v-img class="" alt="" src="/imagenes/simulador_images/imgsimulador.webp"></v-img>
                </v-list-item-avatar>
              </v-list-item>

              <div class="d-flex justify-end mb-5 mr-7">
                <v-chip class="ml-2" small :color="item.estado ? 'green lighten-1' : 'red lighten-1'"
                  text-color="white">
                  <strong>{{ item.estado ? "Activo" : "Inactivo" }}</strong>
                </v-chip>
              </div>

              <v-card-actions class="d-flex justify-center">
                <v-tooltip bottom color="#1b1b1b">
                  <template v-slot:activator="{ on }">
                    <v-btn class="ml-2" @click="
                      listarRespuestasPreguntas(
                        item.tipo_contenido,
                        $event,
                        item.muestra[0].idexamen,
                        item.muestra[0].idusuario
                      )
                      " v-on="on" color="warning" fab x-small dark>
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver muestra</span>
                </v-tooltip>

                <v-tooltip bottom color="#1b1b1b">
                  <template v-slot:activator="{ on }">
                    <v-btn class="ml-2" @click="desactivarSimulador(item.idmuestra, item.tipo_contenido)" x-small
                      elevation="5" right v-on="on" fab color="error" dark>
                      <v-icon> fa fa-times </v-icon>
                    </v-btn>
                  </template>
                  <span>Desactivar muestra</span>
                </v-tooltip>

                <v-tooltip bottom color="#1b1b1b">
                  <template v-slot:activator="{ on }">
                    <v-btn class="ml-2"
                      @click="openVisorExamenesMuestra(item.muestra, item.tipo_contenido, item.clases)" x-small
                      elevation="5" right v-on="on" fab color="primary" dark>
                      <v-icon size="18"> fa fa-users </v-icon>
                    </v-btn>
                  </template>
                  <span>Ver estudiantes</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-col>
        </template>
      </template>

      <!-- PAGINACIÓN -->
      <v-col v-if="!readyloadLista" cols="12" sm="12">
        <v-row class="pt-4">
          <v-col cols="6" sm="2" md="2" lg="2">
            <v-select dense v-model="tamañoPorPagina" :items="tamañosPorPagina" label="Ítems por página"
              @change="cambiarCantidadPaginas">
            </v-select>
          </v-col>
          <v-col cols="6" sm="5" md="5" lg="5">
            <div style="
                display: table;
                height: 0px;
                font-size: 14px;
                font-family: sans-serif;
              ">
              <span style="display: table-cell; vertical-align: middle">
                {{ totalregistros }} registros en total
              </span>
            </div>
          </v-col>

          <v-col class="text-left" cols="12" sm="5" md="5" lg="5">
            <v-pagination color="primary" v-model="paginaActual" :length="totalPaginas" total-visible="7"
              next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @input="cambiarPagina"></v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- DIALOG FULL SCREEN FOR VISOR PREGUNTAS -->
    <v-dialog v-model="VisorPreguntas" fullscreen hide-overlay persistent>
      <v-card>
        <div>
          <v-system-bar height="30" dark window color="primary">
            <v-icon>mdi-comment-question-outline</v-icon>
            <span>SIMULACRO DE EXAMEN</span>
            <v-spacer></v-spacer>
            <v-icon>mdi-minus</v-icon>
            <v-icon>mdi-checkbox-blank-outline</v-icon>
            <v-icon @click="VisorPreguntas = false">mdi-close</v-icon>
          </v-system-bar>
        </div>

        <!-- VISOR PREGUNTAS INTERNO -->
        <template>
          <v-card v-if="showAlertaResult" class="bg">
            <v-window v-model="step">
              <v-window-item v-for="(respta, i) in arrayPreguntasYrespuestas" :value="i + 1" :key="i">
                <v-card-text>
                  <br />
                  <v-row justify="end" align-content="end">
                    <v-col cols="4" style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      ">
                      <h2>
                        <v-icon size="40" color="orange">mdi-comment-question-outline</v-icon>
                        Pregunta {{ i + 1 }}
                      </h2>
                    </v-col>
                    <v-col cols="4" style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      ">
                      <!-- <h1>EXAMEN</h1> -->
                    </v-col>
                    <v-col cols="4" style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      ">
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="8" offset="2" class="pb-0">
                      <div class="pb-0 text-center">
                        <h1 class="pt-2 mb-0" v-html="respta.pregunta"></h1>
                        <!-- <h2 class="text-center">
                              {{ respta.pregunta }}
                            </h2> -->
                      </div>
                    </v-col>
                    <v-col cols="8" offset="2" class="py-0">
                      <v-radio-group v-model="radioGroup">
                        <v-alert v-for="(resptar, n) of respta.respuestas" :key="n" v-model="alertRespuestaLive[n]"
                          color="blue" :style="resptar.valor_respuesta ? 'background:#4eff4e;' : ''
                            " border="left" elevation="3" dense colored-border>
                          <v-radio :disabled="true" @change="validaRespuesta(resptar, respta, i)"
                            style="text-transform: capitalize" :value="resptar.valor_respuesta ? 1 : 0">

                            <template v-slot:label>
                              <div style="padding:10px" v-html="resptar.respuesta"></div>
                            </template>
                          </v-radio>
                        </v-alert>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-window-item>
            </v-window>

            <v-card-actions>
              <v-row>
                <v-col cols="2" class="text-center">
                  <v-btn :disabled="step === 1" color="success" depressed @click="prevpageSimulador">
                    <v-icon>mdi-step-backward</v-icon>

                    Anterior
                  </v-btn>
                </v-col>
                <v-col cols="8" class="text-center align-self-center">
                  <v-progress-linear disabled v-model="cantPreguntas" height="20" rounded>
                    <strong>{{ Math.ceil(cantPreguntas) }}%</strong>
                  </v-progress-linear>
                </v-col>
                <v-col cols="2" class="text-center">
                  <v-btn v-if="step !== contadorPreguntas" :disabled="step === contadorPreguntas" color="primary"
                    depressed @click="nextpageSimulador">
                    Siguiente
                    <v-icon>mdi-step-forward</v-icon>
                  </v-btn>
                  <v-btn v-else :loading="loadingFinalizar" :disabled="loadingFinalizar" color="error" depressed
                    @click="VisorPreguntas = false">
                    Cerrar Muestra
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>

          <v-card v-else color="amber lighten-5" style="margin-top: 5%" class="mx-auto" max-width="400">
            <v-card-title>
              <v-img :src="imgWinOrLose"> </v-img>
            </v-card-title>

            <v-card-text color="orange lighten-2" class="text-h5 orange--text text-center font-weight-bold">
              {{ congratulationOrLose }}
            </v-card-text>

            <v-card-actions>
              <v-list-item class="grow">
                <v-list-item-avatar color="grey darken-3">
                  <v-img class="elevation-6" alt=""
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>Puntaje:</v-list-item-title>
                </v-list-item-content>

                <v-row align="center" justify="center">
                  <span class="subheading mr-2"><strong>{{ aciertos }}</strong></span>
                  <v-icon class="mr-1" color="green"> mdi-check </v-icon>
                  <span class="mr-6">·</span>
                  <span class="subheading"><strong>{{ desaciertos }}</strong></span>
                  <v-icon class="mr-1" color="red"> mdi-close </v-icon>
                </v-row>
              </v-list-item>
            </v-card-actions>

            <br />
            <v-row style="display: block; text-align: center">
              <v-btn @click="VisorPreguntas = false" color="red" class="ma-2 white--text">
                CERRAR
                <!-- <v-icon right dark> mdi-close </v-icon> -->
              </v-btn>
            </v-row>
            <br /><br />
          </v-card>
        </template>
      </v-card>
    </v-dialog>

    <!-- VISOR DE RESULTADOS -->
    <v-dialog v-model="dialogResultados" scrollable max-width="600px">
      <v-card>
        <v-card-title class="modal_title">
          <!-- <v-icon dark left>fas fa-layer-group</v-icon> -->
          Mis resultados
          <v-spacer></v-spacer>
          <v-tooltip bottom color="#1b1b1b">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab dark x-small class="btn_style4 mr-1" @click="verRptas = !verRptas">
                <v-icon>fa-eye</v-icon>
              </v-btn>
            </template>
            <span>{{ verRptas ? 'Ver mis respuestas' : 'Ver respuestas correctas' }}</span>
          </v-tooltip>
          <v-btn fab dark x-small class="btn_style3" @click="dialogResultados = false">
            <v-icon dark>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px">
          <br />
          <v-expansion-panels v-model="panels" multiple>
            <!-- <v-icon color="error"> mdi-alert-circle </v-icon> -->

            <v-expansion-panel v-for="(Misrespuestas, index) in misRespuestasResultados"
              :key="Misrespuestas.idpregunta">
              <v-expansion-panel-header disable-icon-rotate class="pb-0">
                <div>
                  <li style="margin-left: 15px" v-html="'<strong class=claseforzada>' +
                    (index + 1) +
                    ')</strong><br/>' +
                    Misrespuestas.pregunta
                    "></li>
                </div>
                <template v-slot:actions>
                  <v-icon v-if="!verRptas" right size="30" :color="Misrespuestas.valor_pregunta ? 'teal' : 'red'">
                    {{
                      Misrespuestas.valor_pregunta ? "fas fa-check " : "fas fa-times "
                    }}
                  </v-icon>
                  <v-icon v-else right size="30" color="teal">fas fa-check</v-icon>
                </template>
              </v-expansion-panel-header>
              <div v-if="!Misrespuestas.valor_pregunta && !verRptas" class="d-flex pb-4 ml-4">
                <!-- @click="goToVerClase(Misrespuestas)" -->
                <a style="color:red;" @click="goToVerClase(Misrespuestas)" class="text-decoration-none"> <v-icon small
                    color="error" left>fas fa-book-open</v-icon>
                  <div style="font-weight:bold;display: inline;">Ir a repasar
                    unidad :</div> {{ Misrespuestas.nombre_clase }}
                </a>
              </div>

              <v-divider></v-divider>

              <v-expansion-panel-content>
                <v-list shaped>
                  <v-list-item-group color="primary" active-class="border-in">
                    <v-subheader class="d-flex justify-space-between">
                      <strong>
                        <v-icon>far fa-question-circle</v-icon>
                        {{ verRptas ? 'Respuestas correctas:' : 'Mis respuestas:' }}
                      </strong>
                      <small class="pa-5"> <i> {{
                        Misrespuestas.tipo_pregunta == 'res_mul'
                          ? 'Respuesta multiple'
                          : Misrespuestas.tipo_pregunta == 'res_uni'
                            ? 'Respuesta unica'
                            : 'Respuesta verdaderos - falso'
                          }} </i> </small>
                    </v-subheader>

                    <template v-if="verRptas">
                      <v-list-item v-for="nestedRespuestas in Misrespuestas.respuestas_marcadas"
                        :key="nestedRespuestas.idresdpuesta">
                        <v-list-item-icon>
                          <v-icon :color="nestedRespuestas.valor_respuesta ? 'green' : 'red'
                            " dark>{{
                              nestedRespuestas.valor_respuesta
                            ? "fas fa-check"
                            : "fas fa-times"
                            }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title>
                            <li v-html="nestedRespuestas.respuesta"></li>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                    </template>


                    <template v-else>
                      <v-list-item v-for="nestedRespuestas in Misrespuestas.respuestas_marcadas"
                        :key="nestedRespuestas.idresdpuesta">
                        <v-list-item-icon>
                          <v-icon :color="nestedRespuestas.valor_respuesta_marcada ? 'green' : 'red'
                            " dark>{{
                              nestedRespuestas.valor_respuesta_marcada
                            ? "fas fa-check"
                            : "fas fa-times"
                            }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title
                            :class="nestedRespuestas.valor_respuesta == false && Misrespuestas.valor_pregunta == false && nestedRespuestas.valor_respuesta_marcada == true ? 'cruz' : ''">
                            {{ nestedRespuestas.respuesta }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>

                          <v-tooltip left color="error" v-if="(nestedRespuestas.valor_respuesta == false && Misrespuestas.valor_pregunta == false &&
                            nestedRespuestas.valor_respuesta_marcada == true) || (nestedRespuestas.valor_respuesta == true && Misrespuestas.valor_pregunta == false &&
                              nestedRespuestas.valor_respuesta_marcada == false && Misrespuestas.tipo_pregunta ==
                              'res_mul')">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon color="error" dark v-bind="attrs" v-on="on">
                                <v-icon color="error">mdi-information</v-icon>
                              </v-btn>
                            </template>
                            <span> {{
                              nestedRespuestas.valor_respuesta == false && Misrespuestas.valor_pregunta == false &&
                                nestedRespuestas.valor_respuesta_marcada == true
                                ? "Respuesta Incorrecta"
                                : nestedRespuestas.valor_respuesta == true && Misrespuestas.valor_pregunta == false &&
                                  nestedRespuestas.valor_respuesta_marcada == false && Misrespuestas.tipo_pregunta ==
                                  'res_mul' ? "Faltó marcar esta respuesta" : ""
                            }}</span>
                          </v-tooltip>
                          <!-- <strong class="red--text"> {{
                              nestedRespuestas.valor_respuesta == false && Misrespuestas.valor_pregunta == false &&
                              nestedRespuestas.valor_respuesta_marcada == true
                              ? "Respuesta Incorrecta"
                              : nestedRespuestas.valor_respuesta == true && Misrespuestas.valor_pregunta == false &&
                                nestedRespuestas.valor_respuesta_marcada == false && Misrespuestas.tipo_pregunta ==
                                'res_mul' ? "Faltó marcar esta respuesta" : ""
                            }}</strong> -->
                        </v-list-item-action>
                      </v-list-item>
                    </template>


                  </v-list-item-group>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <b>CALIFICACIÓN:</b>
          <v-chip class="ma-2" :color="resultadoVerExamen == 'APROBADO'
            ? 'green accent-4'
            : 'red accent-4'
            " text-color="white">
            <v-avatar left :class="resultadoVerExamen == 'APROBADO' ? 'green darken-4' : 'red'
              ">
              {{ notaPeru }}
            </v-avatar>
            {{ resultadoVerExamen }}:&nbsp;
            <b style="font-size: 18px;"> {{
              // eslint-disable-next-line vue/no-parsing-error
              ((notaPeru * 100 / 20).toFixed(2) >= 0) && ((notaPeru * 100 / 20).toFixed(2) <= 50) ? 'C' : (notaPeru *
                100 / 20).toFixed(2) >= 51 && (notaPeru * 100 / 20).toFixed(2) <= 65 ? 'B' : (notaPeru * 100 /
                  20).toFixed(2) >= 66
                  && (notaPeru * 100 / 20).toFixed(2) <= 85 ? 'A' : (notaPeru * 100 / 20).toFixed(2) >= 86 && (notaPeru *
                    100
                    / 20).toFixed(2) <= 100 ? 'AD' : '' }} </b>

          </v-chip>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DOCENTE VISTA EXAMENES - MUESTRA asdas -->
    <ComunDialogComp v-model="dialogVerMuestra" fullscreen @close-modal="dialogVerMuestra = false">
      <template v-slot:title>
        <v-icon left dark>far fa-list-alt</v-icon> Lista de examenes del área de {{ datoArea }}
      </template>
      <template v-slot:body>
        <v-row>
          <v-col cosl="12">
            <ComundataTablecomp :search="searchQtPreguntas" :headers="headersMuestraExamenes"
              :items="itemMuestraExamenes" whitSearch>
              <!-- ESTE V-SLOT DA ERROR -->
              <template v-slot>
                <v-chip label color="white">
                  <!-- <v-icon> mdi-arrow-down </v-icon> -->
                  El estudiante (s) debe finalizar el examen para ver los resultados*.
                </v-chip>
              </template>

              <template v-slot:accion_opciones="{ item }">
                <v-tooltip bottom color="dark">
                  <template v-slot:activator="{ on }">
                    <v-btn :disabled="item.estado ? true : false" @click="
                      verRespuestasResultados(
                        item.tipo_contenido,
                        $event,
                        item.idexamen,
                        item.idusuario
                      )
                      " v-on="on" class="btn_ver px-0 mx-0" fab x-small>
                      <v-icon>fa fa-book</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver resultados</span>
                </v-tooltip>
              </template>

              <template v-slot:codigo="{ item }">
                <strong>{{ item.codigo }}</strong>
              </template>

              <template v-slot:idusuario="{ item }">
                <strong style="color: orangered">{{
                  item.usuarioexamen[0].persona[0].nombre_completo
                }}</strong>
              </template>

              <template v-slot:descripcion="{ item }">
                <v-chip class="ma-2" small :color="item.descripcion == 'Docente'
                  ? 'green lighten-1'
                  : 'red lighten-1'
                  " text-color="white">
                  <strong>{{ item.autor }}</strong>
                </v-chip>
              </template>

              <template v-slot:fecha_inicio="{ item }">
                <strong> 📅 {{ item.fecha_inicio }} 🕓</strong>
              </template>

              <template v-slot:fecha_fin="{ item }">
                <strong> 📅 {{ item.fecha_fin }} 🕓</strong>
              </template>
              <template v-slot:estado="{ item }">
                <i><strong :style="item.estado ? 'color:#9e9e9e' : 'color:red'">{{
                  item.estado ? "Progreso ..." : "¡FINALIZADO!"
                    }}</strong></i>
                <v-progress-linear :color="item.estado ? 'red lighten-1' : 'green darken-1'" rounded striped top
                  v-model="knowledge" height="15">
                  <strong>{{ !item.estado ? Math.ceil((knowledge = 100)) : 0 }} %</strong>
                </v-progress-linear>
              </template>
            </ComundataTablecomp>
          </v-col>
        </v-row>
      </template>

    </ComunDialogComp>

  </v-container>
</template>

<script>
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import axios from "@/helpers/axios";
import { mapState } from "vuex";
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue';
import { headersMuestraExamenes } from '../../../helpers/headersTable';
import { mapMutations } from 'vuex'

export default {
  name: "simuladorDocenteLista",
  components: {
    // chipSimulador: () => import("../components/Co-chipSimulador.vue"),
    ButtonComp: () => import("../../../components/ComponentsEst/TableButtonComp.vue"),
    ComunDialogComp,
    ComundataTablecomp,
  },
  data: () => ({
    // PROPIEDAD  DEL COMPONENTE CHIP
    chipArrayDiff: [
      {
        color: "warning",
        label: true,
        dark: true,
        dataText: "LISTA DE MUESTRAS",
        icon: "mdi-arrow-down",
      },
    ],
    // PROPIEDADES DE VISTA FINALIZADO EXAMEN
    headersMuestraExamenes,
    showAlertaResult: true,
    congratulationOrLose: "",
    aciertos: 0,
    desaciertos: 0,
    imgWinOrLose: "",
    // PROPIEDADES DE ICONOS
    showGridorList: true,
    // PROPIEDADES DE PAGINACION
    buscando: 0,
    paginaActual: 1,
    totalPaginas: 0,
    tamañoPorPagina: 6,
    tamañosPorPagina: [3, 6, 9],
    totalregistros: 0,
    MensajeNoExisteData: null,
    busquedaValor: "",
    orden: "fecha_creacion",
    titulosColumna: {
      opciones: false,
      codigo: false,
      descripcion: false,
      estado: false,
    },
    ascDescText: "DESC",
    cabecera: [
      {
        clase: "",
        icono: "mdi-cog-outline",
        icono_accion: "mdi-cog-outline",
        valor: "OPCIONES",
        valor_accion: "idmuestra",
        exclusion: true,
      },
      {
        clase: "text-left",
        icono: "mdi-chevron-double-down",
        icono_accion: "mdi-chevron-double-up",
        valor: "N.° DE ESTUDIANTES",
        valor_accion: "idmuestra",
        exclusion: false,
      },
      {
        clase: "text-left",
        icono: "mdi-chevron-double-down",
        icono_accion: "mdi-chevron-double-up",
        valor: "FECHA CREACIÓN",
        valor_accion: "fecha_creacion",
        exclusion: false,
      },
      {
        clase: "text-left",
        icono: "mdi-chevron-double-down",
        icono_accion: "mdi-chevron-double-up",
        valor: "CÓDIGO",
        valor_accion: "codigo",
        exclusion: false,
      },
      {
        clase: "text-left",
        icono: "mdi-chevron-double-down",
        icono_accion: "mdi-chevron-double-up",
        valor: "AUTOR",
        valor_accion: "perfil",
        exclusion: false,
      },
      {
        clase: "text-left",
        icono: "mdi-chevron-double-down",
        icono_accion: "mdi-chevron-double-up",
        valor: "ESTADO",
        valor_accion: "estado",
        exclusion: false,
      },
    ],
    datoLogin: sessionStorage,
    knowledge: 0,
    idmuestraFull: null,
    // PROPIEDADES DE LOGICA VISOR DE SIMULADOR
    loadingFinalizar: false,
    VisorPreguntas: false,
    alertRespuestaLive: [], //LOGICA RESPUESTA DE SIMULADOR
    RespuestaSelected: [], //LOGICA RESPUESTA DE SIMULADOR
    cantPreguntas: 0,
    contadorPreguntas: null,
    step: 1,
    radioGroup: 1,
    totalPag: null,

    // SIDEBAR DE BANCO DE PREGUNTAS
    verPreguntaDrawer: false,
    // VISOR RESULTADOS
    dialogResultados: false,
    itemArrayExamenes: [],

    // LISTAR PREGUNTAS POR CLASE
    arrayPreguntasClase: [],
    arrayPreguntasYrespuestas: [],

    panels: [0, 1, 2, 3, 4],
    misRespuestasResultados: [],
    itemArrayResultado: [],
    audio: new Audio("./audio/PIPIPI.mp3"),

    // PROPIEDADES DE ALERTA DE CONFIRMACION
    mostrarDialogConfirm: false,
    validaDialogConfirm: false,
    mensajeDialog: "",
    claseAnimadaNewExamen: "animate__animated animate__heartBeat",

    // PROPIEDADES PARA ALERTA
    colorsnackbarAlert: "green",
    snackbarAlert: false,
    timeout: 2000,
    SnackbarTextAlert: "",

    itemArrayMuestras: [],
    searchQtPreguntas: null,

    itemMuestraExamenes: [],
    // VISOR EXAMENES MUESTRA
    dialogVerMuestra: false,
    verRptas: false,
    // SKELETON
    readyloadLista: true,

    notaPeru: null,
    resultadoVerExamen: null,
    tipo_contenido: null,
    datoArea: ''
  }),
  methods: {
    ...mapMutations('mensajeSis', ['setEnviarMens']),
    /*------------------------*/
    /* MÉTODO ORDEN x COLUMNA */
    /*------------------------*/
    ordenPorColumna(tituloColumna) {
      const me = this;
      me.orden = tituloColumna;
      Object.keys(me.titulosColumna).forEach((item) => {
        if (item === tituloColumna) {
          me.titulosColumna[tituloColumna] = !me.titulosColumna[tituloColumna];
          me.ascDescText = me.titulosColumna[tituloColumna] ? "ASC" : "DESC";
        } else {
          me.titulosColumna[item] = false;
        }
      });
      me.listarMuestra();
    },


    async obtenerInfoClases(ids_clases, tipo_contenido) {

      try {

        const informacion = await axios.get(`/simulador/simuladorExamen/simuladorMuestras/simuladorM/getinfoClase/${[ids_clases]}/${tipo_contenido}`);

        this.datoArea = informacion.data[0].desc_area;

      } catch (error) {
        console.log(error);
      }
    },

    /*----------------------------*/
    /* MÉTODO OBETENER PARAMETROS */
    /*----------------------------*/
    obtenerParametros(
      valorBusqueda,
      paginaActual,
      tamañoPorPagina,
      orden,
      titulosColumna,
      idusuario,
      perfil
    ) {
      const parametros = {};
      if (valorBusqueda) {
        parametros.valor = valorBusqueda;
      }
      if (paginaActual) {
        parametros.paginaActual = paginaActual - 1;
      }
      if (tamañoPorPagina) {
        parametros.tamañoPorPagina = tamañoPorPagina;
      }
      if (orden) {
        parametros.orden = orden;
      }
      if (titulosColumna) {
        parametros.titulosColumna = titulosColumna;
      }
      if (idusuario) {
        parametros.idusuario = idusuario;
      }
      if (perfil) {
        parametros.perfil = perfil;
      }
      return parametros;
    },

    /*------------------------*/
    /* MÉTODO CAMBIAR PAGINAS */
    /*------------------------*/
    cambiarPagina(numeroPagina) {
      const me = this;
      me.buscando = 0;
      me.paginaActual = numeroPagina;
      me.$store.commit("mostrarLoading", {
        titulo: "Cargando Examenes",
        color: "#fff",
        colorDialog: "#212121",
        ancho: 300,
      });
      me.listarMuestra();
    },

    /*-----------------------------*/
    /* MÉTODO REGISTROS POR PAGINA */
    /*-----------------------------*/
    cambiarCantidadPaginas(tamaño) {
      const me = this;
      me.buscando = 0;
      me.tamañoPorPagina = tamaño;
      me.paginaActual = 1;
      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();

      me.listarMuestra();
    },

    /*--------------------------------*/
    /* FUNCION VISOR EXAMENES MUESTRA */
    /*--------------------------------*/
    async openVisorExamenesMuestra(examenes, tipo_contenido, clases) {
      const me = this;
      me.dialogVerMuestra = true;

      const examenesConTipo = examenes.map(function (items) {
        return { ...items, tipo_contenido: tipo_contenido };
      });

      me.itemMuestraExamenes = examenesConTipo;


      await this.obtenerInfoClases(clases, tipo_contenido)
    },

    /*-------------------------------*/
    /* FUNCION ACCEDER A RUTA CLASES */
    /*-------------------------------*/
    goToVerClase(ItemClases) {
      this.$router.push(`/progDocente/${ItemClases.nombre_clase}`);
    },

    /*----------------------------------------------*/
    /* LISTAR MUESTRAS DEL COLEGIO Y DE INTELIGENIO */
    /*----------------------------------------------*/
    async listarMuestra() {
      const me = this;

      if (me.hearChangeTab) {
        this.$store.commit("changedAnimationTab", {
          classAnimate: "animate__animated animate__heartBeat",
        });

        setInterval(function () {
          me.claseAnimadaNewExamen = "animate__animated animate__heartBeat";
          setTimeout(() => {
            me.claseAnimadaNewExamen = "";
          }, 1000);
        }, 1500);
      }

      const patrametosListar = me.obtenerParametros(
        me.busquedaValor,
        me.paginaActual,
        me.tamañoPorPagina,
        me.orden,
        me.ascDescText,
        me.datoLogin.id,
        me.datoLogin.licencia_perfil.toUpperCase(), //VALIDAR QUE SIEMPRE SEA EL DOCENTE QUIEN EJECUTE ESTO
      );

      try {

        const response = await axios.get(
          "/simulador/simuladorExamen/simuladorMuestras/simuladorM/listarMuestras/",
          {
            params: patrametosListar,
          }
        );


        const { filas, totalPaginas, totalFilas } = response.data;

        if (response.data.message != null) {
          me.MensajeNoExisteData = response.data.message;
        } else {
          setTimeout(async () => {

            const datosSoloColegioActual = filas.map(obj => {
              const muestraFiltrada = obj.muestra.filter(muestra =>
                muestra.usuarioexamen.some(usuario => usuario.id_colegio == this.datoLogin.id_colegio) //filtra solo los colegios
              );
              return { ...obj, muestra: muestraFiltrada };
            }).filter(obj => obj.muestra.length > 0);

            me.itemArrayMuestras = datosSoloColegioActual;


            me.totalPaginas = totalPaginas;
            me.totalregistros = totalFilas || 0;

          }, 300);
        }

        NProgress.done();
        me.$store.commit("ocultarLoading");
        me.readyloadLista = false;

      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /*------------------------------*/
    /* METODO NEXT SIMULADOR WIZZAR */
    /*------------------------------*/
    nextpageSimulador() {
      const me = this;
      me.step++;
      me.cantPreguntas = me.totalPag * me.step;
    },

    /*------------------------------*/
    /* METODO PREV SIMULADOR WIZZAR */
    /*------------------------------*/
    prevpageSimulador() {
      const me = this;
      me.step--;

      if (me.step == 1) {
        me.cantPreguntas = me.totalPag * 0;
      } else {
        me.cantPreguntas = me.totalPag * me.step;
      }
    },

    /*---------------------------*/
    /* VER RESPUESTAS RESULTADOS */
    /*---------------------------*/
    async verRespuestasResultados(tipo_contenido, event, idexamen, idusuario) {
      const me = this;
      let URI;
      if (tipo_contenido == 0) {
        URI = `/simulador/simuladorExamenColegio/simuladorAdmDetalles/simuladorAdmDE/listarAdmPdetalleResultados/${idusuario}/lista/${idexamen}`
      } else {
        URI = `/simulador/simuladorExamen/simuladorDetalles/simuladorDE/listarPdetalleResultados/${idusuario}/lista/${idexamen}`
      }

      try {
        const response = await axios.get(URI);
        const datosRespuestas = response.data.map((number) => {
          return {
            idtema: number.idtema,
            nombre_clase: number.nombre_clase,
            idexamen: number.idexamen,
            idpregunta: number.idpregunta,
            pregunta: number.pregunta,
            tipo_pregunta: number.tipo_pregunta,
            valor_pregunta: number.valor_pregunta,
            respuestas: number.respuestas,
            respuestas_marcadas: number.respuestas_marcadas,
          };
        });

        me.misRespuestasResultados = datosRespuestas;

        let buenas = 0;
        let totalRptas = 0;
        datosRespuestas.forEach((element) => {
          totalRptas++;
          if (element.valor_pregunta) {
            buenas++;
          }
        });

        let result = (buenas * 100) / totalRptas;
        let resultNotaPeru = (result * 20) / 100;

        me.notaPeru = Math.round(resultNotaPeru);

        if (result >= 60) {
          me.resultadoVerExamen = "APROBADO";
        } else {
          me.resultadoVerExamen = "DESAPROBADO";
        }

        me.dialogResultados = true;
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    /*----------------------------*/
    /* LISTAR TODAS LAS PREGUNTAS */
    /*----------------------------*/
    async listarRespuestasPreguntas(tipo_contenido, event, idexamen, idusuario) {
      const me = this;

      let URI;
      if (tipo_contenido == 0) {
        URI = `/simulador/simuladorExamenColegio/simuladorAdmDetalles/simuladorAdmDE/listarAdmPdetalle/${idusuario}/lista/${idexamen}`
      } else {
        URI = `/simulador/simuladorExamen/simuladorDetalles/simuladorDE/listarPdetalle/${idusuario}/lista/${idexamen}`
      }

      me.idexamenFull = idexamen;
      me.cantPreguntas = 0;
      me.arrayPreguntasYrespuestas = [];
      me.contadorPreguntas = null;
      me.totalPag = null;

      if (event && event.keyCode === 122) {
        // 122 is the keycode for F11
        event.preventDefault();
      }
      try {
        const response = await axios.get(URI);


        const datosRespuestas = response.data.map((number) => {
          return {
            idexamen: number.idexamen,
            idpregunta: number.idpregunta,
            pregunta: number.pregunta,
            respuestas: number.respuestas,
          };
        });

        me.arrayPreguntasYrespuestas = datosRespuestas;

        let contadorPag = datosRespuestas.length;
        me.contadorPreguntas = contadorPag;
        me.totalPag = 100 / contadorPag;
        setTimeout(async () => {
          NProgress.done();
          me.VisorPreguntas = true;
          document.documentElement.requestFullscreen();
        }, 800);
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    /*-------------------------------------------------*/
    /* FUNCION VALIDA LA RESPUESTA DEL EXAMEN SIMULADO */
    /*-------------------------------------------------*/
    validaRespuesta(respuestasArray, preguntaArray, posicion) {
      const me = this;

      me.itemArrayResultado[posicion] = {
        idexamen: preguntaArray.idexamen,
        idpregunta: preguntaArray.idpregunta,
        valor_pregunta: respuestasArray.valor_respuesta,
      };
    },
    /*
     ______________________________
    | FUNCION ELIMINAR SIMULADOR */
    async deleteSimulador(idexamen) {
      const me = this;
      me.idexamenFull = idexamen;
      me.mensajeDialog = "¿ Deacuerdo en eliminar el simulador ?";
      me.mostrarDialogConfirm = true;
    },
    /*
     _______________________________
    | FUNCION - DESACTIVAR EXAMEN */
    async confirmDeleteMuestra() {

      const me = this;

      try {
        const response = await axios.delete(
          `/simulador/simuladorExamen/simuladorMuestras/simuladorM/eliminarMuestra/${me.idmuestraFull}/${me.tipo_contenido}`,
        );
        await me.listarMuestra();
        me.idmuestraFull = null;

        this.setEnviarMens({ tipo: 'S', mensaje: response.data.message, tiempo: null })
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      } finally {
        me.mostrarDialogConfirm = false;
      }

    },
    /*
     _______________________________
    | FUNCION - DESACTIVAR EXAMEN */
    async confirmDeleteExamen() {

      const me = this;

      try {
        const response = await axios.put(
          "/simulador/simuladorExamen/simuladorExamenes/simuladorE/archivar",
          {
            idexamen: me.idexamenFull,
          }
        );

        me.mostrarDialogConfirm = false;
        await me.listarMuestra();
        me.mostrarSnackbar = true;
        me.mensajeAlerta = response.data.message;
        me.idexamenFull = null;
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }

    },

    /*------------------------------------*/
    /* FUNCION DESACTIVAR MUESTRA MUESTRA */
    /*-------------------------------------*/
    async desactivarSimulador(idmuestra, tipo_contenido) {

      const me = this;
      me.idmuestraFull = idmuestra;
      me.tipo_contenido = tipo_contenido;
      me.mensajeDialog = "¿ Está seguro de desactivar la muestra ?";
      me.mostrarDialogConfirm = true;
    },

    /*-----------------------------*/
    /* GUARDAR SIMULADOR ALEATORIO */
    /*-----------------------------*/
    async guardarExamenResult() {
      const me = this;

      let cantidadp = this.itemArrayResultado.filter(
        (item) => Object.keys(item).length !== 0
      ).length;

      if (cantidadp != me.step) {
        let preguntasquefaltan = Number(me.step) - Number(cantidadp);
        me.snackbarAlert = true;
        me.colorsnackbarAlert = "red";
        me.SnackbarTextAlert =
          "Te faltan contestar " + preguntasquefaltan + " pregunta (s)";
        return false;
      }

      me.showAlertaResult = false;
      me.loadingFinalizar = true;
      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();

      try {
        let aciertos = me.itemArrayResultado
          .map((obj) => obj.valor_pregunta)
          .reduce((acc, curr) => (curr ? acc + 1 : acc), 0);

        let result = (aciertos * 100) / cantidadp;
        let desaciertos = cantidadp - aciertos;

        me.aciertos = aciertos;
        me.desaciertos = desaciertos;

        if (result >= 50) {
          me.congratulationOrLose = "👏 ¡FELICIDADES! 👏";
          me.imgWinOrLose = "./imagenes/simulador_images/congratulations.webp";
          me.$confetti.start();
        } else {
          me.congratulationOrLose = "🥺 ¡BUEN INTENTO! 🥺";
          me.imgWinOrLose = "./imagenes/simulador_images/nicetry.jpg";

          // me.audio.play();
        }

        await axios.post(
          "/simulador/simuladorExamen/simuladorDetalles/simuladorDE/updateDetalle/",
          {
            resultados: me.itemArrayResultado,
            idexamen: me.idexamenFull,
          }
        );
        me.buscando = 1;
        // console.log(respuesta);

        setTimeout(async () => {
          NProgress.done();
          me.loadingFinalizar = false;
          await me.listarMuestra();
        }, 800);
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    /*----------------*/
    /* FUNCION INICIO */
    /*----------------*/
    async init() {
      const me = this;
      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();

      if (me.buscando !== 1) {
        me.$store.commit("mostrarLoading", {
          titulo: "Cargando Examenes",
          color: "#fff",
          colorDialog: "#212121",
          ancho: 300,
        });
      }

      await me.listarMuestra();
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState(["hearChangeTab"]),
  },
  watch: {
    VisorPreguntas(e) {
      const me = this;
      if (!e) {
        me.idexamenFull = null;
        me.arrayPreguntasYrespuestas = [];
        me.itemArrayResultado = [];
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        // me.audio.close();
        me.$confetti.stop();
        me.showAlertaResult = true;
      }
    },
  },
};
</script>

<style>
.v-expansion-panel-content__wrap {
  padding-bottom: 0;
}

strong.claseforzada {
  position: absolute;
  top: 33px;
  left: 15px;
}

.shrink-column {
  width: 25%;
  white-space: nowrap;
}

.shrink-column_estado {
  width: 25%;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .v-simple-table {
    overflow-x: auto;
  }
}

.border-in {
  border: 2px dashed orange;
}

.cruz {
  position: absolute;
  text-decoration: none;
}

.cruz::before,
.cruz::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #ff000061;
  top: 40%;
  bottom: 0%;
  /* transform: rotate(-30deg); */
  left: 0;
  /* left: 0; */
}

.v-list-item__title.cruz {
  padding: 5px;
}

/* GUADADOP */
</style>
